import { render, staticRenderFns } from "./TransferAudit.vue?vue&type=template&id=af8b5e40&"
import script from "./TransferAudit.vue?vue&type=script&lang=js&"
export * from "./TransferAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports